export default {
  props: {
    resource: {
      type: Object,
      required: true,
    },
  },
  computed: {
    blockName() {
      if (
        !Object.keys(this.$options.components).includes(
          this.resource.resource_class_name
        )
      ) {
        return "Unknown";
      }
      return this.resource.resource_class_name;
    },
  }
}
